import { createTheme } from "@mui/material/styles";
export const theme = createTheme({
    palette: {
      primary: {
        main: "#4db970"
      },
      secondary:{
        main:"#fe805c"
      }
    },
    components:{
      MuiButton:{
        styleOverrides:{
          root:{
            '&:hover':{
              backgroundColor:'#dbf8e5'
            }
          }
          
        } as any
      },
      MuiIconButton:{
        styleOverrides:{
          root:{
            '&:hover':{
              backgroundColor:'#dbf8e5'
            }
          }
          
        } as any
      }
    }
  });